export const STATUS_COLOR = {
    NEW_REQUEST: {
        color: 'rgb(180, 1, 1)',
        bgColor: 'rgb(253, 236, 232)'
    },
    NEEDS_RESUBMISSION: {
        color: 'rgb(199, 135, 17)',
        bgColor: 'rgb(255, 246, 231)'
    },
    RESUBMITTED: {
        color: 'rgb(161, 9, 161)',
        bgColor: 'rgb(255, 232, 255)'
    },
    IN_PROGRESS: {
        color: 'rgb(139, 139, 0)',
        bgColor: 'rgb(255, 255, 215)'
    },
    SIGNING_PENDING: {
        color: 'rgb(255, 143, 162)',
        bgColor: 'rgb(255, 236, 239)'
    },
    SIGNED: {
        color: 'rgb(13, 1, 180)',
        bgColor: 'rgb(232, 232, 253)'
    },
    PAYMENT_ASKED: {
        color: 'rgb(0, 0, 0)',
        bgColor: 'rgb(221, 221, 221)'
    },
    PAYMENT_DONE: {
        color: 'rgb(15, 201, 160)',
        bgColor: 'rgb(223, 255, 248)'
    },
    COMPLETED: {
        color: 'rgb(0, 97, 0)',
        bgColor: '#e6ffe6'
    }
}

